import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CompanyCenterProvider extends HttpRequest {
  findAll () {
    return this.get('/contact-channel')
  }

  findAllChannel () {
    return this.get('/contact-channel/channelt/all')
  }

  createGroup (payload) {
    return this.post('/contact-channel', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/contact-channel/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/contact-channel/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/contact-channel?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default CompanyCenterProvider
